<template>
    <div>
        <div class="flex-page-content flex-container">
            <div class="flex-body body-scroll">
                <div class="container-fluid">

                    <div class="container my-4">
                        <div class="row">
                            <div class="col-12">
                                <h3>Email Testing Tool</h3>

                                <p>
                                    Use this tool to send test emails simulating what a user would receive.
                                </p>

                                <form @submit.prevent class="mt-4">
                                    <form-errors :errors="formErrors" :errorsHtml="formErrorsHtml" />

                                    <div class="form-row mb-3">
                                        <div class="col-3">
                                            <form-input label="Email Type" v-model="formData.email_type" :errors="errors.email_type" type="select" :options="emailTypeOptions" extraclasses="label--bold"/>
                                        </div>

                                        <div class="col-3 offset-1">
                                            <form-input label="Client Number" v-model="formData.client_code" :errors="errors.client_code" type="text" inputmode="numeric" />
                                        </div>
                                    </div>

                                    <div class="form-row mb-3">
                                        <div class="col-3">
                                            <form-input label="Client Recipient" v-model="formData.client_recipient" :errors="errors.client_recipient" type="email" helper-text="Email of user you're trying to simulate" />
                                        </div>
                                        <div class="col-3 offset-1">
                                            <form-input label="Actual Recipient" v-model="formData.actual_recipient" :errors="errors.actual_recipient" type="email" helper-text="Email address you want to deliver to" />
                                        </div>
                                    </div>

                                    <div class="form-row mb-3" v-if="formData.email_type == 'weekly-warnings-recap'">
                                        <div class="col-3">
                                            <form-input label="Start Date" v-model="formData.date_start" :errors="errors.date_start" type="native-date" />
                                        </div>
                                        <div class="col-3 offset-1">
                                            <form-input label="End Date" v-model="formData.date_end" :errors="errors.date_end" type="native-date" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col">
                                            <button class="btn btn-outline-primary" @click="sendTestEmail">Send Test Email</button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormMixin from '@/mixins/Form'
import api from '@/api'

const emailTypeOptions = [
    {text: 'Weekly Warnings Recap', value: 'weekly-warnings-recap'},
]

export default {
    mixins: [FormMixin, ],
    data() {
        return {
            formRules: {
                email_type: {presence: {allowEmpty: false}},
                client_code: {presence: {allowEmpty: false}},
                client_recipient: {presence: {allowEmpty: false}},
                actual_recipient: {presence: {allowEmpty: false}},
            },
            formErrorsHtml: [],
            formData: this.makeFormData(),
            debugOutput: '',
        }
    },
    computed: {
        emailTypeOptions() {return emailTypeOptions},
    },
    methods: {
        makeFormData() {
            return {
                email_type: '',
                client_code: '',
                client_recipient: '',
                actual_recipient: '',
                date_start: '',
                date_end: '',
            }
        },
        sendTestEmail() {
            if (!this.validate()) {
                return
            }

            this.$store.dispatch('START_LOADING')
            this.$api.post(`/admin/email-tester`, this.getFormData()).then(resp => {
                if (resp['status'] == 'OK') {
                    this.$bus.showInfo(`Sent test email to ${this.formData.actual_recipient}`)
                } else {
                    this.errors = resp['errors']
                    this.formErrors = resp['errors'].__all__
                }
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
                this.$store.dispatch('STOP_LOADING')
            })
        },
    },
}
</script>
